import request from '@/utils/request'

// 获取会员数据
export async function api_getDashboardMemberData(params) {
  return request({
    url: '/rest/dashboard/member/data',
    method: 'get',
    params,
  })
}
// 获取会员图标数据
export async function api_getDashboardMemberChart(params) {
  return request({
    url: '/rest/dashboard/member/chart',
    method: 'get',
    params,
  })
}
// 获取交易数据
export async function api_getDashboardTradeData(params) {
  return request({
    url: '/rest/dashboard/trade/data',
    method: 'get',
    params,
  })
}
// 获取交易图标数据
export async function api_getDashboardTradeCountChart(params) {
  return request({
    url: '/rest/dashboard/trade/count/chart',
    method: 'get',
    params,
  })
}
// 获取交易图标数据
export async function api_getDashboardTradeAmountChart(params) {
  return request({
    url: '/rest/dashboard/trade/amount/chart',
    method: 'get',
    params,
  })
}



// 获取业态/店铺消费数据
export async function api_getDashboardStoreDataChart(params) {
  return request({
    url: '/rest/dashboard/store/type/chart',
    method: 'get',
    params,
  })
}
